/**
 * Get an array of unique dates based on the month and day portion of date strings.
 *
 * @param {Array<{updated_at: string, user: string, value: string}>} dates - An array of date objects.
 * @param {string} selectedDate - A reference date string.
 * @returns {Array<{updated_at: string, user: string, value: string}>} - An array of object with unique dates.
 */

const getUniqueDatesByDate = (dates, selectedDate) => {
    const currentDateObj = new Date(selectedDate)
    const currentDateString = `${currentDateObj.getMonth()}-${currentDateObj.getDate()}-${currentDateObj.getHours()}-${currentDateObj.getMinutes()}`
    const uniqueDateIds = new Set()
    uniqueDateIds.add(currentDateString)

    const res = dates.reduce(
        (acc, dateObj) => {
            const currentDateObj = new Date(dateObj.value)
            const dateId = `${currentDateObj.getMonth()}-${currentDateObj.getDate()}-${currentDateObj.getHours()}-${currentDateObj.getMinutes()}`

            if (!acc.uniqueDateIds.has(dateId)) {
                acc.uniqueDateIds.add(dateId)
                acc.uniqueDates.push(dateObj)
            }

            return acc
        },
        { uniqueDateIds, uniqueDates: [] }
    ).uniqueDates

    return res
}

export default getUniqueDatesByDate
